export type CapabilityTier = 'modern' | 'safe'

type CapabilityInput = {
  webgl2?: boolean
  reducedMotion?: boolean
  saveData?: boolean
  pointer?: string
  hardwareConcurrency?: number
  deviceMemory?: number
  viewportWidth?: number
  mobile?: boolean
}

export function getCapabilityTier(input: CapabilityInput): CapabilityTier {
  if (!input.webgl2 || input.reducedMotion || input.saveData || input.pointer !== 'fine' || input.mobile) return 'safe'
  if ((input.hardwareConcurrency ?? 99) <= 2 || (input.deviceMemory ?? 99) <= 2 || (input.viewportWidth ?? 9999) <= 720) return 'safe'
  return 'modern'
}

export function readCapabilities(): CapabilityTier {
  const connection = (navigator as Navigator & { connection?: { saveData?: boolean } }).connection
  let webgl2 = false
  try { webgl2 = Boolean(document.createElement('canvas').getContext('webgl2')) } catch { webgl2 = false }
  return getCapabilityTier({
    webgl2,
    reducedMotion: window.matchMedia('(prefers-reduced-motion: reduce)').matches,
    saveData: connection?.saveData,
    pointer: window.matchMedia('(pointer: fine)').matches ? 'fine' : 'coarse',
    hardwareConcurrency: navigator.hardwareConcurrency,
    deviceMemory: (navigator as Navigator & { deviceMemory?: number }).deviceMemory,
    viewportWidth: window.innerWidth,
    mobile: /Android|iPhone|iPad|Mobile/i.test(navigator.userAgent)
  })
}
